import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'components/Button';

// <editor-fold desc="SupportIntro type definitions ...">

export type SupportIntroProps = {
  description: string;
};
// </editor-fold>

// <editor-fold desc="SupportIntro component definition ...">
const SupportIntro = ({ description }: SupportIntroProps): JSX.Element => {
  const { t } = useTranslation();

  const defaultIntroText = t(
    'Täältä löydät apua ja tukea palveluidemme käyttöön. Ennen yhteydenottoa käythän läpi ohjeet ja vinkit sekä yleisimmät kysymykset.\n' +
      '\n' +
      'Tiituksen tuki on auki arkisin klo 9-15. Pyrimme vastaamaan kaikkiin yhteydenottopyyntöihin mahdollisimman nopeasti.\n' +
      '\n' +
      'Yhteydenotot: support@tiitus.fi'
  );

  return (
    <Container>
      <Row>
        <Col xs={12} className="p-4">
          <h2 className="text-primary">{t('Tiitus Support')}</h2>
          <p>
            {
              <Trans
                i18nKey="SupportDefaultIntroText" // optional -> fallbacks to defaults if not provided
                defaults={defaultIntroText} // optional defaultValue
              />
            }
          </p>
          <Button href="https://www.tiitus.fi/tuki/yhteystiedot" target="_blank">
            {t('Siirry supporttiin')}
          </Button>
          <div className="mt-3">
            <a 
              href="https://www.tiitus.fi/legal/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-decoration-none"
            >
              {t('Käyttöehdot ja tietosuojaseloste')}
            </a>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
// </editor-fold>

export default SupportIntro;
